import { AccountStatus } from "src/types/commonTypes";

export const SUPPORTER = "SUPPORTER";
export const PARTICIPANT = "PARTICIPANT";
export const INTERNAL_ADMIN = "INTERNAL_ADMIN";
export const INTERNAL_ADMIN_READ_ONLY = "INTERNAL_ADMIN_READ_ONLY";
export const SUPER_ADMIN = "ORGANISATION_SUPER_ADMIN";
export const OPERATIONS_MANAGER = "ORGANISATION_OPERATIONS_MANAGER";
export const FINANCE_MANAGER = "ORGANISATION_FINANCE_MANAGER";
export const NOVATTI_DAILY_TRANSACTION = "NOVATTI_DAILY_TRANSACTION";
export const NOVATTI_CARD_TRANSACTION = "NOVATTI_CARD_TRANSACTION";
export const WALLET_TRANSACTION = "WALLET_TRANSACTION";
export const ADJUSTMENT = "ADJUSTMENT";
export const DEPOSIT_WITHDRAWAL = "DEPOSIT_WITHDRAWAL";
export const WALLET_TO_WALLET_TRANSFER = "WALLET_TO_WALLET_TRANSFER";
export const CASH_TRANSACTION = "CASH_TRANSACTION";
export const CORPORATE = "CORPORATE";
export const INDIVIDUAL = "INDIVIDUAL";
export const REFERER = "REFERER";
export const CREATED_FOR_SELF = "SELF";
export const CREATED_FOR_OTHER = "OTHER";
export const SHARED = "SHARED";
export const PRIVATE = "PRIVATE";
export const CAN_ADD_USER = "CAN_ADD_USER";
export const CAN_ADD_CARD = "CAN_ADD_CARD";
export const CAN_UPDATE_CARD = "CAN_UPDATE_CARD";
export const CAN_CHANGE_CARD_PIN = "CAN_CHANGE_CARD_PIN";
export const CAN_EDIT_USER_INFORMATION = "CAN_EDIT_USER_INFORMATION";
export const CAN_EDIT_TRANSACTION = "CAN_EDIT_TRANSACTION";
export const CAN_UPDATE_WALLET = "CAN_UPDATE_WALLET";
export const CAN_UPDATE_WALLET_SETTINGS = "CAN_UPDATE_WALLET_SETTINGS";
export const CAN_UPDATE_BUDGET = "CAN_UPDATE_BUDGET";
export const CAN_UPDATE_REPEAT_PAY = "CAN_UPDATE_REPEAT_PAY";
export const CAN_CONNECT_USER_TO_WALLET = "CAN_CONNECT_USER_TO_WALLET";
export const CAN_CONNECT_CARD_TO_WALLET = "CAN_CONNECT_CARD_TO_WALLET";
export const CAN_CONNECT_CARD = "CAN_CONNECT_CARD";
export const CAN_CONNECT_CARD_TO_ORGANISATION = "CAN_CONNECT_CARD_TO_ORGANISATION";
export const CAN_CONNECT_WALLET_TO_ORGANISATION = "CAN_CONNECT_WALLET_TO_ORGANISATION";
export const CAN_CONNECT_USER_TO_ORGANISATION = "CAN_CONNECT_USER_TO_ORGANISATION";
export const CAN_UPDATE_ORGANISATION = "CAN_UPDATE_ORGANSIATION";
export const CAN_CHANGE_PIN = "CAN_CHANGE_PIN";
export const CAN_UPDATE_USER_ROLE = "CAN_UPDATE_USER_ROLE";
export const CAN_UPDATE_USER_SETTINGS = "CAN_UPDATE_USER_SETTINGS";
export const CAN_UPDATE_USER_KYC = "CAN_UPDATE_USER_KYC";
export const CAN_TAGGED_USER = "CAN_TAGGED_USER";
export const CAN_CONNECT_WALLET_TO_USER = "CAN_CONNECT_WALLET_TO_USER";
export const CAN_RESET_PASSWORD = "CAN_RESET_PASSWORD";
export const CAN_ADD_WALLET = "CAN_ADD_WALLET";
export const CAN_UPDATE_EMAIL = "CAN_UPDATE_EMAIL";
export const CAN_TOGGLE_CARD_STATUS = "CAN_TOGGLE_CARD_STATUS";
export const CAN_ACT_ON_QUICK_LINKS = "CAN_ACT_ON_QUICK_LINKS";
export const CAN_ACCESS_ONBOARDING = "CAN_ACCESS_ONBOARDING";
export const CAN_DEPOSIT = "CAN_DEPOSIT";
export const CAN_DEPOSIT_TO_CASH_WALLET = "CAN_DEPOSIT_TO_CASH_WALLET";
export const CAN_REPORT_CASH_TRANSACTION = "CAN_REPORT_CASH_TRANSACTION";
export const CAN_UPGRADE_CARD = "CAN_UPGRADE_CARD";
export const CAN_TRANSFER_BETWEEN_WALLET = "CAN_TRANSFER_BETWEEN_WALLET";
export const CAN_LOAD_CARD = "CAN_LOAD_CARD";
export const CAN_VIEW_SUBSCRIPTION_PLAN = "CAN_VIEW_SUBSCRIPTION_PLAN";
export const CAN_ACCESS_ORDER_CARD_BUTTON = "CAN_ACCESS_ORDER_CARD_BUTTON";
export const CAN_CREATE_GENERAL_WALLET = "CAN_CREATE_GENERAL_WALLET";
export const CAN_CREATE_CASH_WALLET = "CAN_CREATE_CASH_WALLET";
export const CAN_SEE_HOW_TO_DEPOSIT = "CAN_SEE_HOW_TO_DEPOSIT";
export const CAN_SEE_CARD_ON_USER_DETAIL = "CAN_SEE_CARD_ON_USER_DETAIL";
export const CAN_BLOCK_MERCHANT = "CAN_BLOCK_MERCHANT";
export const CAN_BLOCK_ACCOUNT_MERCHANT = "CAN_BLOCK_ACCOUNT_MERCHANT";
export const VIEW_USER_WIDGET_IN_WALLET_DETAIL = "VIEW_USER_WIDGET_IN_WALLET_DETAIL";
export const CAN_CREATE_ORGANISATION = "CAN_CREATE_ORGANISATION";
export const CAN_CREATE_GROUP = "CAN_CREATE_GROUP";
export const CAN_CONNECT_USER_TO_GROUP = "CAN_CONNECT_USER_TO_GROUP";
export const CAN_UPDATE_GROUP = "CAN_UPDATE_GROUP";
export const CAN_CONNECT_CARD_TO_GROUP = "CAN_CONNECT_CARD_TO_GROUP";
export const CAN_TRANSFER_PARTICIPANT_TO_PARTICIPANT = "CAN_TRANSFER_PARTICIPANT_TO_PARTICIPANT";
export const CAN_TRANSFER_GROUP_TO_GROUP = "CAN_TRANSFER_GROUP_TO_GROUP";
export const CAN_TRANSFER_PARTICIPANT_TO_GROUP = "CAN_TRANSFER_PARTICIPANT_TO_GROUP";
export const CAN_TRANSFER_GROUP_TO_PARTICIPANT = "CAN_TRANSFER_GROUP_TO_PARTICIPANT";
export const CAN_TRANSFER_MASTER_TO_PARTICIPANT = "CAN_TRANSFER_MASTER_TO_PARTICIPANT";
export const CAN_TRANSFER_MASTER_TO_GROUP = "CAN_TRANSFER_MASTER_TO_GROUP";
export const CAN_UPDATE_GROUP_MANAGER = "CAN_UPDATE_GROUP_MANAGER";
export const CAN_CREATE_GROUP_WALLET = "CAN_CREATE_GROUP_WALLET";
export const CAN_LOAD_CARD_FOR_GROUP = "CAN_LOAD_CARD_FOR_GROUP";
export const CAN_CONNECT_XERO = "CAN_CONNECT_XERO";
export const CAN_ACCESS_ALL_USERS_IN_ORG = "CAN_ACCESS_ALL_USERS_IN_ORG";
export const CAN_ACCESS_ALL_TRANSACTIONS = "CAN_ACCESS_ALL_TRANSACTIONS";
export const CAN_ACCESS_RECURRING_TRANSACTION = "CAN_ACCESS_RECURRING_TRANSACTION";
export const CAN_VIEW_TRANSACTION_DETAIL = "CAN_VIEW_TRANSACTION_DETAIL";
export const CAN_UPLOAD_IMAGE_IN_TRANSACTION = "CAN_UPLOAD_IMAGE_IN_TRANSACTION";
export const CAN_ADD_NOTES_IN_TRANSACTION = "CAN_ADD_NOTES_IN_TRANSACTION";
export const CAN_CREATE_EXPENSE = "CAN_CREATE_EXPENSE";
export const CAN_CONNECT_USER_TO_EXPENSE = "CAN_CONNECT_USER_TO_EXPENSE";
export const CAN_ATTACH_CARD_TRANSACTION_TO_EXPENSE = "CAN_ATTACH_CARD_TRANSACTION_TO_EXPENSE";
export const CAN_INSTANT_DEPOSIT = "CAN_INSTANT_DEPOSIT";
export const CAN_ORDER_CARD = "CAN_ORDER_CARD";
export const CAN_BUY_SUBSCRIPTION = "CAN_BUY_SUBSCRIPTION";
export const CAN_UNLINK_USER_FROM_ORGANISATION = "CAN_UNLINK_USER_FROM_ORGANISATION";
export const CAN_APPROVE_TRANSACTION = "CAN_APPROVE_TRANSACTION";
export const CAN_VERIFY_TRANSACTION = "CAN_VERIFY_TRANSACTION";
export const CAN_MARK_TRANSACTION_AS_DRAFT = "CAN_MARK_TRANSACTION_AS_DRAFT";
export const CAN_ADD_ATTRIBUTE_CATALOG = "CAN_ADD_ATTRIBUTE_CATALOG";
export const CAN_UPDATE_LICENSE = "CAN_UPDATE_LICENSE";
export const CAN_REQUIRE_WALLET_STEP_ON_USER_CREATE = "CAN_AUTO_CREATE_WALLET_ON_USER_CREATE";
export const CAN_CREATE_REIMBURSEMENT = "CAN_CREATE_REIMBURSEMENT";
export const CAN_APPROVE_REIMBURSEMENT = "CAN_APPROVE_REIMBURSEMENT";
export const CAN_BULK_UPLOAD_CASH_TRANSACTION = "CAN_BULK_UPLOAD_CASH_TRANSACTION";
export const CAN_BULK_UPLOAD_DEPOSIT = "CAN_BULK_UPLOAD_DEPOSIT";
export const CAN_BULK_UPLOAD_CREATE_USER = "CAN_BULK_UPLOAD_CREATE_USER";
export const CAN_BULK_UPLOAD_GL_CODE = "CAN_BULK_UPLOAD_GL_CODE";
export const CAN_BULK_UPLOAD_TRACKING_CODE = "CAN_BULK_UPLOAD_TRACKING_CODE";
export const CAN_BULK_UPLOAD_ACCOUNTING_CATEGORY = "CAN_BULK_UPLOAD_ACCOUNTING_CATEGORY";

/**
 * Permission -> the bulk-upload file types it unlocks. loginSlice turns the
 * signed-in user's permissions into the modal's file-type dropdown.
 *
 * One permission maps to MANY types so that a single grant covers both the "add
 * new" and "update existing" variants of the same thing — splitting them would
 * mean six permissions to administer for three concepts.
 *
 * ACCOUNTING-CODE UPLOADS ARE WITHDRAWN. GL, tracking and accounting-category
 * types are deliberately absent, so the dropdown never offers them and no such
 * upload can be started — by any user, whatever permissions they hold. This map
 * is the only gate the UI has, so removing the entries is what actually disables
 * the feature; the CAN_BULK_UPLOAD_*_CODE permissions below are kept only so
 * existing grants keep resolving, and re-adding an entry here re-enables it.
 * Codes are maintained one at a time on the Accounting Codes page instead.
 */
export const BULK_UPLOAD_PERMISSION_TO_FILE_TYPE: Record<string, string[]> = {
  [CAN_BULK_UPLOAD_CASH_TRANSACTION]: ["CASH_TRANSACTION"],
  [CAN_BULK_UPLOAD_DEPOSIT]: ["DEPOSIT"],
  [CAN_BULK_UPLOAD_CREATE_USER]: ["CREATE_USER"]
};

export const EMPTY_STRING = "";
export const EMPTY_VALUE = "-";

export const DEFAULT_COUNTRY_CODE = "+61";
export const DEFAULT_COUNTRY = "Australia";

export const MIN_ORG_NAME_LENGTH = 2;
export const SUSPICIOUS_NAME_TOKENS = ["undefined", "null"] as const;

export const ACCOUNT_STATUS = {
  DRAFT: "DRAFT",
  SUBMITTED: "SUBMITTED",
  APPROVED: "APPROVED",
  READY: "READY",
  REJECTED: "REJECTED"
} as const;

export const BALANCE_CUTOFF_DATE = "2024-03-13T00:00:00Z";

export const DEFAULT_CURRENCY = "AUD";

/**
 * Customer-facing names for the accounting statuses. The stored enum is unchanged —
 * this is presentation only, so search filters, AVP actions and the audit trail all
 * keep working on DRAFT/SUBMITTED/APPROVED/READY.
 *
 * The review chain is presented as two approvers rather than "approver" and
 * "verifier", so APPROVED means the first of two has signed off:
 *
 *   DRAFT     -> Unsubmitted
 *   SUBMITTED -> Pending
 *   APPROVED  -> Approved 1 of 2
 *   READY     -> Approved
 *
 * "1 of 2" is dropped when there is no second approver. In practice APPROVED does
 * not rest without one — transaction-service auto-transitions APPROVED -> READY
 * when a card has no verifiers — but a caller that knows the reviewer list can say
 * so explicitly rather than briefly showing a count that will not happen.
 */
export const ACCOUNTING_STATUS_LABELS: Record<string, string> = {
  [ACCOUNT_STATUS.DRAFT]: "Unsubmitted",
  [ACCOUNT_STATUS.SUBMITTED]: "Pending",
  [ACCOUNT_STATUS.APPROVED]: "Approved 1 of 2",
  [ACCOUNT_STATUS.READY]: "Approved",
  [ACCOUNT_STATUS.REJECTED]: "Rejected"
};

export const accountingStatusLabel = (status?: string | null, hasSecondApprover = true): string => {
  if (!status) return EMPTY_STRING;
  if (status === ACCOUNT_STATUS.APPROVED && !hasSecondApprover) return "Approved";
  return ACCOUNTING_STATUS_LABELS[status] ?? status;
};

export const ACCOUNT_STATUS_TRANSITIONS: Record<string, string[]> = {
  [ACCOUNT_STATUS.DRAFT]: [ACCOUNT_STATUS.SUBMITTED],
  [ACCOUNT_STATUS.SUBMITTED]: [ACCOUNT_STATUS.APPROVED, ACCOUNT_STATUS.REJECTED],
  [ACCOUNT_STATUS.APPROVED]: [ACCOUNT_STATUS.READY, ACCOUNT_STATUS.REJECTED],
  [ACCOUNT_STATUS.REJECTED]: [ACCOUNT_STATUS.SUBMITTED],
  [ACCOUNT_STATUS.READY]: []
};

export const ACTION_REQUIRED_TO_ACCOUNT_STATUS: Record<string, AccountStatus> = {
  RECEIPT_REQUIRED: ACCOUNT_STATUS.DRAFT,
  APPROVAL_REQUIRED: ACCOUNT_STATUS.SUBMITTED,
  VERIFICATION_REQUIRED: ACCOUNT_STATUS.APPROVED
};

export const permissionMapping: Record<string, string> = {
  [CAN_ADD_CARD]: CAN_ACCESS_ORDER_CARD_BUTTON
};

export const planCategoryMapping: Record<string, string> = {
  BASE: "Base",
  TOP_UP: "Top Up"
};

// CPC role labels (terminology refresh per Reece 2026-08-24): the client roles are
// Team Member (the cardholder) / Finance Manager / Admin. Supporter and Operations
// Manager ("Finance Admin") are LEGACY platform roles kept here only so existing
// records still render a label — they are not selectable anywhere (see the arrays
// below). PARTICIPANT is the cardholder and now renders as "Team Member".
export const roleMapping: Record<string, string> = {
  ORGANISATION_SUPER_ADMIN: "Admin",
  ORGANISATION_FINANCE_MANAGER: "Finance Manager",
  PARTICIPANT: "Team Member",
  INTERNAL_ADMIN: "Internal Admin",
  INTERNAL_ADMIN_READ_ONLY: "Read-Only Admin",
  // legacy, render-only (not selectable):
  SUPPORTER: "Supporter",
  ORGANISATION_OPERATIONS_MANAGER: "Finance Admin",
  NOROLE: EMPTY_STRING
};

export const activityNameMapping: Record<string, string> = {
  NOVATTI_CARD_TRANSACTION: "Card Transaction",
  NOVATTI_DAILY_TRANSACTION: "Novatti Daily Transaction",
  WALLET_TRANSACTION: "Card Transfer",
  CASH_TRANSACTION: "Cash Transaction",
  DEPOSIT: "Deposit",
  CREATE_USER: "Create User"
};

export const activityStatusMapping: Record<string, string> = {
  SETTLED: "Settled",
  APPROVED: "Approved",
  DECLINED: "Declined",
  RETURNED: "Returned"
};

export const reportTypeMapping: Record<string, string> = {
  ORGANISATION_DAILY_EVALUATION: "Organisation Daily Evaluation",
  LICENCE_DAILY_EVALUATION: "Licence Daily Evaluation",
  WALLET_DAILY_REPORT: "Card Daily Report",
  DOWNLOAD_WALLET: "Download Card Balance",
  DOWNLOAD_ACTIVITY: "Transaction Report",
  DOWNLOAD_CARD: "Download Card",
  DOWNLOAD_USER: "User Report",
  DOWNLOAD_BANK_STATEMENT: "Bank Statement",
  DOWNLOAD_EXPENSE_BY_MEMBER: "Expense by Cardholder/Card",
  DOWNLOAD_MISSING_RECEIPTS: "Missing Receipts",
  DOWNLOAD_AWAITING_ACTION: "Awaiting Action"
};

export const reportStageMapping: Record<string, string> = {
  STAGE_1: "Stage 1",
  STAGE_2: "Stage 2",
  STAGE_3: "Stage 3",
  STAGE_4: "Stage 4",
  STAGE_5: "Stage 5"
};

export const bucketNameMapping: Record<string, string> = {
  ORGANISATION_REGISTERED: "Organisation Registered",
  SUBSCRIPTION_SELECTED: "Subscription Selected",
  USERS_CREATED: "Users Created",
  WALLETS_CREATED: "Cards Created",
  PRE_TRANSACTION: "Pre Transaction",
  TRANSACTED: "Transacted"
};

export const walletTypeToActivityName: Record<string, string> = {
  GENERAL: "NOVATTI_CARD_TRANSACTION",
  SPENDING: "NOVATTI_CARD_TRANSACTION",
  DIGITAL: "NOVATTI_CARD_TRANSACTION",
  CASH: "CASH_TRANSACTION",
  SERVICE: "NOVATTI_CARD_TRANSACTION"
};

export const walletTypeMapping: Record<string, string> = {
  GENERAL: "General",
  SPENDING: "Spending",
  DIGITAL: "Digital",
  GROUP: "Group",
  CASH: "Cash",
  SERVICE: "Service",
  CREDIT: "Credit"
};

export const cardTypeMapping: Record<string, string> = {
  SHARED: "Shared",
  PRIVATE: "Private"
};

export const GROUP_TYPE = {
  SITE: "SITE",
  COST_CENTRE: "COST_CENTRE"
} as const;

export const groupTypeMapping: Record<string, string> = {
  [GROUP_TYPE.SITE]: "Site",
  [GROUP_TYPE.COST_CENTRE]: "Cost Centre"
};

export const activeStatusMapping: Record<string, boolean> = {
  ACTIVE: true,
  INACTIVE: false
};

export const reverseActiveStatusMapping: Record<string, string> = {
  true: "ACTIVE",
  false: "INACTIVE"
};

export const REIMBURSEMENT_STATUS = {
  DRAFT: "DRAFT",
  SUBMITTED: "SUBMITTED",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
  SETTLED: "SETTLED",
  CANCELLED: "CANCELLED"
} as const;

export const reimbursementStatusMapping: Record<string, string> = {
  [REIMBURSEMENT_STATUS.DRAFT]: "Draft",
  [REIMBURSEMENT_STATUS.SUBMITTED]: "Submitted",
  [REIMBURSEMENT_STATUS.APPROVED]: "Approved",
  [REIMBURSEMENT_STATUS.REJECTED]: "Rejected",
  [REIMBURSEMENT_STATUS.SETTLED]: "Settled",
  [REIMBURSEMENT_STATUS.CANCELLED]: "Cancelled"
};

export const REIMBURSEMENT_DESTINATION_WALLET_TYPES = ["GENERAL", "GROUP", "SERVICE"];

export const recurringTransferTypeMapping: Record<string, string> = {
  FIXED: "Fixed",
  TOPUP: "Top Up"
};

// Contemporary Trust U+ roles only — legacy SUPPORTER and OPERATIONS_MANAGER
// dropped (they are render-only labels now, not assignable).
export const rolesCanBeAdded = [
  "ORGANISATION_SUPER_ADMIN",
  "ORGANISATION_FINANCE_MANAGER",
  "PARTICIPANT",
  "INTERNAL_ADMIN"
];

// CPC-4/CPC-5: the only roles that can be assigned to new users in the CPC
// deployment. Client users get the client roles; internal admins can also
// create internal users.
export const CPC_CLIENT_ROLES = [SUPER_ADMIN, FINANCE_MANAGER, PARTICIPANT];
export const CPC_INTERNAL_ROLES = [INTERNAL_ADMIN, INTERNAL_ADMIN_READ_ONLY];

export const reverseRoleMapping: Record<string, string> = {
  ["Admin"]: "ORGANISATION_SUPER_ADMIN",
  ["Internal Admin"]: "INTERNAL_ADMIN",
  ["Read-Only Admin"]: "INTERNAL_ADMIN_READ_ONLY",
  ["Member"]: "PARTICIPANT",
  ["Supporter"]: "SUPPORTER",
  ["Finance Admin"]: "ORGANISATION_OPERATIONS_MANAGER",
  ["Finance Manager"]: "ORGANISATION_FINANCE_MANAGER",
  // Legacy labels, kept so stale persisted state still resolves.
  ["Super Admin"]: "ORGANISATION_SUPER_ADMIN",
  ["Participant"]: "PARTICIPANT",
  ["Team member"]: "PARTICIPANT",
  ["Team Member"]: "PARTICIPANT",
  ["Operations Manager"]: "ORGANISATION_OPERATIONS_MANAGER",
  ["Guardian"]: "ORGANISATION_FINANCE_MANAGER"
};

export const walletUserRole = [PARTICIPANT, SUPER_ADMIN];

// Roles selectable as approvers / verifiers. Includes PARTICIPANT (Team Member) —
// team members can be approvers (client feedback 2026-08). Single source of truth
// for the approver pickers (card, wallet, participant, accounting settings).
export const APPROVER_ROLES = [
  SUPER_ADMIN,
  FINANCE_MANAGER,
  INTERNAL_ADMIN,
  PARTICIPANT
];

export const walletSpendFrequencyMapping: Record<string, string> = {
  NONE: "None",
  DAILY: "Daily",
  WEEKLY: "Weekly",
  BIWEEKLY: "Fortnightly",
  MONTHLY: "Monthly"
};

export const walletResetLimitMapping: Record<string, string> = {
  "0": "Sunday",
  "1": "Monday",
  "2": "Tuesday",
  "3": "Wednesday",
  "4": "Thursday",
  "5": "Friday",
  "6": "Saturday"
};

/** Card/asset object-type discriminator used by create_card / update_card. */
export const CARD_OBJECT_TYPE = {
  USER: "USER",
  GROUP: "GROUP"
} as const;

// CPC uses Active/Inactive language for cards; BLOCK is the backend event
// behind "Inactive".
export const cardStatusMapping: Record<string, string> = {
  ACTIVE: "Active",
  INACTIVE: "Inactive",
  BLOCKED: "Inactive",
  DRAFT: "Draft",
  CANCELED: "Canceled",
  HOLD: "Hold",
  ORDERED: "Ordered"
};

export const convertCardStatusToCardEventAction: Record<string, string> = {
  ACTIVE: "UNBLOCK",
  INACTIVE: "BLOCK",
  BLOCKED: "BLOCK",
  DRAFT: "DRAFT",
  CANCELED: "CANCEL",
  HOLD: "HOLD"
};

export const expenseTypeMapping: Record<string, string> = {
  OFFLINE: "Offline",
  GROUP: "Group",
  BILL: "Bill",
  CARD: "Card"
};

export const gstTypeMapping: Record<string, string> = {
  NONE: "None",
  INCLUDED: "Included",
  EXCLUDED: "Excluded"
};

export const CHUNK_FAILED_MESSAGE = "Failed to load a required script. Try reloading the page.";

export const fileProcessStatusMapping: Record<string, string> = {
  PENDING: "Pending",
  CREATED: "Created",
  INITIATED: "Initiated",
  PROCESSING: "Processing",
  COMPLETED: "Completed",
  FAILED: "Failed",
  REJECTED: "Rejected"
};

export const fileTypeMapping: Record<string, string> = {
  CASH_TRANSACTION: "Cash transaction",
  DEPOSIT: "Deposit",
  NOVATTI_DAILY_TRANSACTION: "Novatti daily transaction",
  CREATE_USER: "Create user",
  UPDATE_ORGANISATION: "Update organisation",
  UPDATE_SUBSCRIPTION_TO_ORGANISATION_RELATIONSHIP: "Update subscription",
  UPDATE_MCC: "Update MCC",
  UPDATE_USER_PASSWORD: "Update user password",
  WALLET_ADJUSTMENT: "Card adjustment",
  CREATE_ATTRIBUTE_CATALOG: "Create attribute catalog",
  CREATE_GL_CODE: "GL codes — add new",
  UPDATE_GL_CODE: "GL codes — update existing",
  CREATE_ACCOUNTING_CATEGORY: "Accounting categories — add new",
  UPDATE_ACCOUNTING_CATEGORY: "Accounting categories — update existing",
  CREATE_TRACKING_CODE: "Tracking codes — add new",
  UPDATE_TRACKING_CODE: "Tracking codes — update existing"
};
